import { fork, call, put, all, takeEvery } from "redux-saga/effects";
import asyncInterface from "../../../asyncInterface";
import { getPrimaryAccount, isGeminiUser } from "../../../utils/sessionUtil";
import * as actionTypes from "./actionTypes";
import { logOut } from '../../../Auth0/SessionProvider';

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendGrant.fetchAccountData(fetchPayload);
}

export function submitUserData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendGrant.postCharityData(fetchPayload);
}

export function* investmentDataFetch(data) {
  yield put({ type: actionTypes.fetchInvestmentDataType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.fetchInvestmentDataSuccessType,
      payload: response.data
    });
  } catch (error) { }
}

export function* grantsDataFetch(data) {
  yield put({ type: actionTypes.fetchGrantsDataType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.fetchGrantsDataSuccessType,
      payload: response.data
    });
  } catch (error) {}
}

export function* contributionDataFetch(data) {
  yield put({ type: actionTypes.fetchContributionDataType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.fetchContributionDataSuccessType,
      payload: response.data
    });
  } catch (error) { }
}

export function* allAccountSummaryDataFetch(data) {
  yield put({ type: actionTypes.fetchAllAccountSummaryDataType });
  try {
    const response = yield call(fetchAccountData, data);

    yield put({
      type: actionTypes.fetchAllAccountSummaryDataSuccessType,
      payload: response.data
    });
  } catch (error) { }
}

export function* setAccountSummaryData(payload) {
  yield put({
    type: actionTypes.fetchAccountSummaryBalanceDataSuccessType,
    payload
  });
}

export function* accountSummaryDataFetch(data, allData) {
  let _self = {};
  _self.validateUserId = getPrimaryAccount().userId;
  yield put({ type: actionTypes.fetchAccountSummaryBalanceDataType });
  try {
    const response = yield call(fetchAccountData, data);
    if (getPrimaryAccount().userId == response.data.seqAccountId) {
      if (response.data.y3 == true) {
        yield all([fork(setAccountSummaryData, response.data)]);
        yield put({
          type: actionTypes.fetchAccountSummaryBot3YrType,
          payload: ""
        });
      } else {
        yield put({
          type: actionTypes.fetchAccountSummaryBalanceDataSuccessType,
          payload: response.data
        });
      }
    } else {
    }
  } catch (error) { }
}

export function* accountDataFetch(data) {
  yield put({ type: actionTypes.fetchAccountDataType });
  try {
    const response = yield call(fetchAccountData, data);
    if (getPrimaryAccount().accountName == response.data.accountName) {
      yield put({
        type: actionTypes.fetchAccountDataSuccessType,
        payload: response.data
      });
    }
  } catch (error) {
    const geminiUser = isGeminiUser();
    if (geminiUser === undefined || geminiUser !== true) {
        logOut("sessionTimeOut")
    }
  }
}

export function* otherTransactionDataFetch(data) {
  yield put({ type: actionTypes.fetchOtherTransactionDataType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.fetchOtherTransactionDataSuccessType,
      payload: response.data
    });
  } catch (error) { }
}

export function* myAccountDataFetch(data) {
  yield put({ type: actionTypes.fetchMyAccountDataType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.fetchMyAccountDataSuccessType,
      payload: response.data
    });
  } catch (error) { }
}

export function* fetchAccountSummaryWorker(fetchPayload) {
  yield all([
    fork(investmentDataFetch, fetchPayload.payload[0]),
    fork(grantsDataFetch, fetchPayload.payload[1]),
    fork(contributionDataFetch, fetchPayload.payload[2]),
    fork(
      accountSummaryDataFetch,
      fetchPayload.payload[3],
      fetchPayload.payload[6]
    ),
    fork(accountDataFetch, fetchPayload.payload[4]),
    fork(otherTransactionDataFetch, fetchPayload.payload[5]),
    fork(myAccountDataFetch, fetchPayload.payload[7])
  ]);
}
export function* fetchBOTWorker(data) {
  yield put({ type: actionTypes.fetchAllAccountSummaryDataType });
  try {
    const response = yield call(fetchAccountData, data.payload.metaData);

    yield put({
      type: actionTypes.fetchAllAccountSummaryDataSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: actionTypes.fetchAllAccountSummaryDataType });
  }
}

export function* fetchAccountSummaryWatcher() {
  yield takeEvery(
    actionTypes.fetchAccountSummaryDataType,
    fetchAccountSummaryWorker
  );
}
export function* fetchBOTWatcher() {
  yield takeEvery(actionTypes.fetchBotDataType, fetchBOTWorker);
}

export default function* AccountSummary() {
  yield all([fork(fetchAccountSummaryWatcher), fork(fetchBOTWatcher)]);
}
